// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Reorder: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.5 22.5">
            <path
                fill="currentColor"
                stroke="currentColor"
                stroke-width=".5"
                d="M11.25.25c6.075 0 11 4.925 11 11s-4.925 11-11 11-11-4.925-11-11 4.925-11 11-11Zm0 .733C5.58.983.983 5.58.983 11.25c0 5.67 4.597 10.267 10.267 10.267 5.67 0 10.267-4.597 10.267-10.267C21.517 5.58 16.92.983 11.25.983Zm4.723 3.843.035.03 2.304 2.304-2.304 2.304a.367.367 0 0 1-.55-.484l.031-.034 1.456-1.456-.104-.006c-.767-.034-1.611.047-2.408.311-1.607.534-2.615 1.688-2.79 3.686.17 1.955 1.139 3.093 2.686 3.626l.101.034c.815.263 1.682.333 2.467.286l-1.408-1.408a.367.367 0 0 1-.03-.484l.03-.034a.367.367 0 0 1 .484-.03l.035.03 2.304 2.304-2.304 2.304a.367.367 0 0 1-.55-.484l.031-.034 1.432-1.433-.07.006c-.843.042-1.763-.04-2.646-.325-1.29-.416-2.264-1.2-2.814-2.392-.458 1.28-1.604 2.076-3.214 2.46l-.12.027c-.956.213-1.956.264-2.87.218l-.21-.012a6.87 6.87 0 0 1-.313-.027.367.367 0 0 1 .085-.728l.172.015.105.008c.906.061 1.922.022 2.873-.19 1.855-.413 2.939-1.364 2.983-3.042l.001-.108.002-.089c.002-.17.01-.335.023-.496a8.014 8.014 0 0 1-.023-.497l-.001-.089v-.087c-.029-1.224-1.104-1.963-2.971-2.301a13.432 13.432 0 0 0-2.718-.186l-.232.008c-.11.005-.189.01-.228.013a.367.367 0 0 1-.057-.731l.196-.012.057-.003a14.315 14.315 0 0 1 3.113.19c1.613.292 2.783.887 3.291 1.858.52-1.236 1.478-2.057 2.757-2.51l.11-.037a7.48 7.48 0 0 1 2.664-.348l-1.377-1.376a.367.367 0 0 1-.03-.484l.03-.035a.367.367 0 0 1 .484-.03Z"
            />
        </svg>
    );
};

export default React.memo(Reorder);
